import { Component, OnInit } from '@angular/core';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { DialogRef, ModalComponent } from 'angular2-modal';
import { Router, NavigationStart } from '@angular/router';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { AppSettings } from '../../sharedcomponents/_common/constants/app.constants';

export class CustomModalContext extends BSModalContext {
  public modalData: any;
}
@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css'],
  providers: [Modal,utilityService]
})
export class AboutUsComponent implements OnInit, ModalComponent<CustomModalContext> {
  context: CustomModalContext;
  modalData: any;
  pageurl = '';
  pageArray = [];
  constructor(public dialog: DialogRef<CustomModalContext>, private modal: Modal, private router: Router, public utilserv: utilityService) {
    this.modalData = this.dialog.context.modalData;
    this.getPageUrl(this.modalData.URL);
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });
    this.context = dialog.context;
    this.context.dialogClass = 'clsAdditionalPopup';

  }

  ngOnInit() {}
  getPageUrl(route) {
    route = route.replace('/', '');
    this.utilserv.busy =  this.utilserv.restGet(AppSettings.ICEMasterService + '/GetAboutPrivacyURL', true).subscribe(data => {
      this.pageurl = data[route];
    });
  }
  continueClick() {
    this.dialog.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/about-us/about-us.component.ts